import { render, staticRenderFns } from "./RporteVentasPedidosPagos.vue?vue&type=template&id=2ddf32e2&scoped=true"
import script from "./RporteVentasPedidosPagos.vue?vue&type=script&lang=js"
export * from "./RporteVentasPedidosPagos.vue?vue&type=script&lang=js"
import style0 from "./RporteVentasPedidosPagos.vue?vue&type=style&index=0&id=2ddf32e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf32e2",
  null
  
)

export default component.exports